module.exports = "<div class=userdata-wrap> <router-view></router-view> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/appBackend/components/page/userdata/userdata/userdata.tpl
// module id = 931
// module chunks = 2